const $ = require("jquery");
const slick = require('slick-carousel')


export default class Slick {
    constructor() {
    }
    init() {
        $('.js-slide').slick({
            dots: true,
            infinite: true,
            slidesToShow: 1,
            autoplay: true,
            speed: 800,
            autoplaySpeed: 4000,
            adaptiveHeight: true,
            pauseOnFocus: false,
        });
    }
};
